import { useProductCardImage } from '../hooks/useProductCardImage'

export default function ProductImage({
  item,
  alt = '',
  className,
  style,
  onClick,
  onKeyDown,
  role,
  tabIndex,
}) {
  const { src, onError } = useProductCardImage(item)
  if (!src) {
    return <div className="image-placeholder" aria-hidden="true">🖼️</div>
  }
  return (
    <img
      key={src}
      src={src}
      alt={alt}
      className={className}
      style={style}
      role={role}
      tabIndex={tabIndex}
      onClick={onClick}
      onKeyDown={onKeyDown}
      onError={onError}
    />
  )
}
